enum AutoTriggerOffsetProperty {
  EffectiveScheduledDate = "EffectiveScheduledDate",
  CompleteDate = "CompleteDate",
}

export { AutoTriggerOffsetProperty };
